import { Component, ElementRef, Input, OnInit } from '@angular/core';
import { Pagination } from "../../core/models/pagination.model";
import { environment } from "../../../environments/environment";
import { JwtService } from "../../core/services/jwt.service";
import 'rxjs/add/operator/map';
import { EmployeeService } from "../../core/services/employee.service";
import { CommonService } from "../../core/services/common.service";

@Component({
    selector: 'app-employee-list-table',
    templateUrl: './employee-list-table.component.html',
    styleUrls: ['./employee-list-table.component.css']
})
export class EmployeeListTableComponent implements OnInit {

    @Input()
    pagination: Pagination;

    @Input()
    verifications: any[];

    clientUrl: string;
    crmUrl: string;
    token: string;

    filterParams: URLSearchParams = new URLSearchParams();

    constructor(
        private jwtService: JwtService,
        private el: ElementRef,
        private employeeService: EmployeeService,
        private commonService: CommonService
    ) { }

    ngOnInit() {
        this.clientUrl = environment.client_url;
        this.crmUrl = environment.crm_url;
        this.token = this.jwtService.getToken();

    }

    downloadDocuments(employee, i) {

        this.employeeService.getDocuments(employee.id, this.filterParams).subscribe(response => {
            if (response.success) {
                window.location.href = this.clientUrl + 'employees/' + employee.id + '/download-documents?download=yes&token=' + this.token;
            }
            else {
                this.commonService.notifications.error('No Documents To Download');
            }

        });
    }

}



// WEBPACK FOOTER //
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/src/app/employee/employee-list-table/employee-list-table.component.ts